// extracted by mini-css-extract-plugin
export default {"wrapper":"Pay_wrapper__HPfmB","header":"Pay_header__cmEJd","goBack":"Pay_goBack__fiRTz","container":"Pay_container__L2Y0h"};